
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'
import ExchangeTabsComp from './views/Tabs/index.vue'
import PackItemComp from './views/Coupon/index.vue'
import HowToUse from './views/HowToUse/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { EnumCouponStatus } from '@xt/client/enums'
import { EnumMyAccountPacksFilter } from '@xt/client/enums/my'

@Observer
@Component({
  components: {
    ExchangeTabsComp,
    PackItemComp,
    EmptyStatus,
    HowToUse
  }
})
export default class MyAccountPacks extends Vue {
  loading: boolean = true
  isError: boolean = false
  showHowToUseModal: boolean = false
  tabActiveKey: number = +lodash.get(this.$route.query, 'active', EnumMyAccountPacksFilter.All.toString())

  get filterCouponType() {
    return this.tabActiveKey === EnumMyAccountPacksFilter.All ||
      this.tabActiveKey === EnumMyAccountPacksFilter.Used ||
      this.tabActiveKey === EnumMyAccountPacksFilter.Expired
      ? undefined
      : `${this.tabActiveKey}00`
  }

  get filterStatus() {
    return this.tabActiveKey === EnumMyAccountPacksFilter.Used
      ? EnumCouponStatus.Used
      : this.tabActiveKey === EnumMyAccountPacksFilter.Expired
        ? EnumCouponStatus.Expired
        : undefined
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get PageStore() {
    return this.$store.$coupon.myPacks
  }

  async onTabChange(active: number) {
    if (this.tabActiveKey === active) return

    this.tabActiveKey = active

    this.fetchPacksList()

    document.documentElement.scrollTo({ top: 0 })
  }

  closeHowToUseModal() {
    this.showHowToUseModal = false
  }

  onReceive(data: { id: number; youzanDetail: any }) {
    const cloneList = [...this.toJS(this.PageStore.myPacksList)].map(v => {
      if (v.id === data.id) {
        lodash.set(v, 'wenfangMemberHeader', data.youzanDetail.avatar)
        lodash.set(v, 'wenfangMemberNickname', data.youzanDetail.userNickname)
        lodash.set(v, 'wenfangPhoneNum', data.youzanDetail.userPhone)
        lodash.set(v, 'wenfangReceived', true)
      }
      return v
    })
    this.PageStore.setMyPacksList(cloneList)
  }

  onExchange(id: number) {
    const cloneList = [...this.toJS(this.PageStore.myPacksList)].map(v => {
      if (v.id === id) {
        lodash.set(v, 'status', EnumCouponStatus.Used)
      }
      return v
    })
    this.PageStore.setMyPacksList(cloneList)
  }

  async fetchPacksList() {
    this.loading = true
    try {
      await this.PageStore.onGetMyPacks(this.filterCouponType, this.filterStatus)
      this.isError = false
    } catch (error) {
      this.isError = true
    } finally {
      this.loading = false
    }
  }

  created(): void {
    this.fetchPacksList()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
